<template>
  <Grid
    class="plants-grid"
    :data-items="facilities"
    :columns="columns"
    :loader="loading"
    data-cy="plants-grid"
  >
    <template v-slot:NameStatusCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span class="plants-grid__name-status"
          >{{ dataItem.Name }} <br />
          {{ dataItem.StatusDisplayName }}</span
        >
      </td>
    </template>
    <template v-slot:AddressCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span>{{ getAddress(dataItem) }}</span>
      </td>
    </template>
    <template v-slot:JewishOwnedCell="{ props: { dataItem } }">
      <td class="k-table-td">
        <span>{{ dataItem.JewishOwned ? "Yes" : "No" }}</span>
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { Grid } from "@progress/kendo-vue-grid";
import { onBeforeMount, ref } from "vue";
import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type { Facility } from "@/Domain/Facility";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { useMainStore } from "@/stores/useMainStore";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { api } from "@/api";

const main = useMainStore();
const notificationStore = useNotificationStore();

const facilities = ref<Facility[]>([]);
const loading = ref(false);

const columns = ref<GridColumnPropsExtended[]>([
  {
    title: "Name & Status",
    field: "Name",
    cell: "NameStatusCell",
  },
  {
    title: "Address",
    field: "Street1",
    cell: "AddressCell",
  },
  {
    title: "Visiting Rabbi",
    field: "DesignatedRfrName",
  },
  {
    title: "Jewish Owned",
    field: "JewishOwned",
    cell: "JewishOwnedCell",
  },
]);

const getAddress = (facility: Facility) => {
  return `${facility.Street1} ${facility.Street2} ${facility.Street3} ${facility.City}, ${facility.State} ${facility.Country} ${facility.Zip}`;
};

const getFacilitiesAsync = async function () {
  loading.value = true;

  const requestParams = {
    userLogin: main.userLogin,
    companyLogin: main.companyLogin,
    includeMainOffice: false,
    subApplication: 10,
    contactId: -1,
    includeSpecial: true,
  };

  await handleResponsePromiseAsync(
    api.get("GetFacilities", requestParams),
    (data) => {
      facilities.value = data;
    },
    "ChometzSalesPlantsTable.vue",
    "getFacilitiesAsync",
    () => {
      notificationStore.notify({
        message: `Plant Info Error Encountered`,
        type: NotificationTypeEnum.error,
        duration: 5000,
      });
    }
  );

  loading.value = false;
};

onBeforeMount(() => {
  getFacilitiesAsync();
});
</script>

<style scoped lang="scss">
.plants-grid {
  max-height: 350px;

  .plants-grid__name-status {
    color: #337ab7;
  }
}
</style>
